module.exports = ".card-title {\n  font-weight: 600; }\n\n.card-description {\n  font-weight: 600; }\n"